// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionItemFormController from "./action_item_form_controller"
application.register("action-item-form", ActionItemFormController)

import ActionItemImportController from "./action_item_import_controller"
application.register("action-item-import", ActionItemImportController)

import ActionItemPdfViewerController from "./action_item_pdf_viewer_controller"
application.register("action-item-pdf-viewer", ActionItemPdfViewerController)

import ActionItemsController from "./action_items_controller"
application.register("action-items", ActionItemsController)

import ActivityFeedController from "./activity_feed_controller"
application.register("activity-feed", ActivityFeedController)

import AllBidsExportController from "./all_bids_export_controller"
application.register("all-bids-export", AllBidsExportController)
import AccessRowController from "./access_row_controller"
application.register("access-row", AccessRowController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import MobileAppGateController from "./mobile_app_gate_controller"
application.register("mobile-app-gate", MobileAppGateController)

import EnterSubmitController from "./enter_submit_controller"
application.register("enter-submit", EnterSubmitController)

import AttendanceSheetController from "./attendance_sheet_controller"
application.register("attendance-sheet", AttendanceSheetController)

import ApiKeysController from "./api_keys_controller"
application.register("api-keys", ApiKeysController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import AccFieldMappingsController from "./acc_field_mappings_controller"
application.register("acc-field-mappings", AccFieldMappingsController)

import ReportTabsController from "./report_tabs_controller"
application.register("report-tabs", ReportTabsController)

import OwnerCardBadgeController from "./owner_card_badge_controller"
application.register("owner-card-badge", OwnerCardBadgeController)

// § 3.7 Tier 3 — partner-scope API keys (CRUD + rotation flow)
import PartnerApiKeysController from "./partner_api_keys_controller"
application.register("partner-api-keys", PartnerApiKeysController)

// § 3.7 Tier 3 — partner usage dashboard (60s polling tiles + charts)
import PartnerUsageController from "./partner_usage_controller"
application.register("partner-usage", PartnerUsageController)

// § 3.7 Tier 4 — sandbox provisioning modal + 3s status poll loop
import SandboxProvisioningController from "./sandbox_provisioning_controller"
application.register("sandbox-provisioning", SandboxProvisioningController)

// § 3.7 Tier 5 — partner doc show page (TOC highlight + thumbs vote)
import PartnerDocPageController from "./partner_doc_page_controller"
application.register("partner-doc-page", PartnerDocPageController)

// § 3.7 Tier 5 — partner training show page (Mixpanel on load)
import PartnerWalkthroughPageController from "./partner_walkthrough_page_controller"
application.register("partner-walkthrough-page", PartnerWalkthroughPageController)

// § 3.7 Tier 5 — admin CRUD + drag-reorder for partner walkthroughs
import IntegrationAdminPartnerWalkthroughsController from "./integration_admin_partner_walkthroughs_controller"
application.register("integration-admin-partner-walkthroughs", IntegrationAdminPartnerWalkthroughsController)

// § 3.7 Tier 6 — admin: partner support ticket triage queue
import IntegrationAdminPartnerTicketsController from "./integration_admin_partner_tickets_controller"
application.register("integration-admin-partner-tickets", IntegrationAdminPartnerTicketsController)

import TimesheetsController from "./timesheets_controller"
application.register("timesheets", TimesheetsController)
import TimesheetDayMapController from "./timesheet_day_map_controller"
application.register("timesheet-day-map", TimesheetDayMapController)
import DayColumnsController from "./day_columns_controller"
application.register("day-columns", DayColumnsController)
import TimeListsController from "./time_lists_controller"
application.register("time-lists", TimeListsController)
import TimeRatesController from "./time_rates_controller"
application.register("time-rates", TimeRatesController)
import TimeDavisBaconController from "./time_davis_bacon_controller"
application.register("time-davis-bacon", TimeDavisBaconController)
import DavisBaconFieldController from "./davis_bacon_field_controller"
application.register("davis-bacon-field", DavisBaconFieldController)
import CertifiedPayrollController from "./certified_payroll_controller"
application.register("certified-payroll", CertifiedPayrollController)
// Codes & lists → Mapping and Export (Kloepfer K6-8, 2026-10-09).
import TimeMappingController from "./time_mapping_controller"
application.register("time-mapping", TimeMappingController)
// The signature box in the finance sign pop-ups: Type, Draw or Upload (CL1-1, 2026-10-10).
import SignatureBoxController from "./signature_box_controller"
application.register("signature-box", SignatureBoxController)
// Company Settings → Timesheets: the time clock's company switches (2026-10-09).
import TimeCompanySettingsController from "./time_company_settings_controller"
application.register("time-company-settings", TimeCompanySettingsController)
import TimePlacesController from "./time_places_controller"
application.register("time-places", TimePlacesController)
import TimeHolidaysController from "./time_holidays_controller"
application.register("time-holidays", TimeHolidaysController)
import TimeOffController from "./time_off_controller"
application.register("time-off", TimeOffController)
import TimeReceiptsController from "./time_receipts_controller"
application.register("time-receipts", TimeReceiptsController)
import TimeExportCheckController from "./time_export_check_controller"
application.register("time-export-check", TimeExportCheckController)
// A word search on top of the time tracker settings' lists (K8-22, 2026-10-10).
import ListSearchController from "./list_search_controller"
application.register("list-search", ListSearchController)

import WebhooksController from "./webhooks_controller"
application.register("webhooks", WebhooksController)

import AddPropertyController from "./add_property_controller"
application.register("add-property", AddPropertyController)

import ArchitectFormController from "./architect_form_controller"
application.register("architect-form", ArchitectFormController)

import AprFormController from "./apr_form_controller"
application.register("apr-form", AprFormController)

import Admin__BuilderOfferController from "./admin/builder_offer_controller"
application.register("admin--builder-offer", Admin__BuilderOfferController)
import Admin__OwnerPlansController from "./admin/owner_plans_controller"
application.register("admin--owner-plans", Admin__OwnerPlansController)
import Admin__WireRenewalController from "./admin/wire_renewal_controller"
application.register("admin--wire-renewal", Admin__WireRenewalController)
import Admin__UserMoveController from "./admin/user_move_controller"
application.register("admin--user-move", Admin__UserMoveController)

import Admin__SearchController from "./admin/search_controller"
application.register("admin--search", Admin__SearchController)
import Admin__EmailLogController from "./admin/email_log_controller"
application.register("admin--email-log", Admin__EmailLogController)

import Admin__ResendInviteController from "./admin/resend_invite_controller"
application.register("admin--resend-invite", Admin__ResendInviteController)

import Admin__SidebarController from "./admin/sidebar_controller"
application.register("admin--sidebar", Admin__SidebarController)
import Admin__McpTabsController from "./admin/mcp_tabs_controller"
application.register("admin--mcp-tabs", Admin__McpTabsController)

import Admin__UsersController from "./admin/users_controller"
application.register("admin--users", Admin__UsersController)
import Admin__CompaniesController from "./admin/companies_controller"
application.register("admin--companies", Admin__CompaniesController)

import Admin__CompanyMergeController from "./admin/company_merge_controller"
application.register("admin--company-merge", Admin__CompanyMergeController)

import AllPhasesSearchController from "./all_phases_search_controller"
application.register("all-phases-search", AllPhasesSearchController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BidCountdownController from "./bid_countdown_controller"
application.register("bid-countdown", BidCountdownController)

import BidDocumentsController from "./bid_documents_controller"
application.register("bid-documents", BidDocumentsController)

import BidFormController from "./bid_form_controller"
application.register("bid-form", BidFormController)

import BidTooltipController from "./bid_tooltip_controller"
application.register("bid-tooltip", BidTooltipController)

import BudgetController from "./budget_controller"
application.register("budget", BudgetController)

import BudgetTransferDeleteController from "./budget_transfer_delete_controller"
application.register("budget-transfer-delete", BudgetTransferDeleteController)

import BudgetTransferNewController from "./budget_transfer_new_controller"
application.register("budget-transfer-new", BudgetTransferNewController)

import BudgetSnapshotsController from "./budget_snapshots_controller"
application.register("budget-snapshots", BudgetSnapshotsController)

import BudgetFormulaColumnsController from "./budget_formula_columns_controller"
application.register("budget-formula-columns", BudgetFormulaColumnsController)

import EvaController from "./eva_controller"
application.register("eva", EvaController)

import EvaChartsController from "./eva_charts_controller"
application.register("eva-charts", EvaChartsController)

import EvaSchedulePanelController from "./eva_schedule_panel_controller"
application.register("eva-schedule-panel", EvaSchedulePanelController)

import EvaSnapshotsController from "./eva_snapshots_controller"
application.register("eva-snapshots", EvaSnapshotsController)

import CashFlowController from "./cash_flow_controller"
application.register("cash-flow", CashFlowController)

import CashFlowChartsController from "./cash_flow_charts_controller"
application.register("cash-flow-charts", CashFlowChartsController)

import CashFlowForecastsController from "./cash_flow_forecasts_controller"
application.register("cash-flow-forecasts", CashFlowForecastsController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import PortfolioCashFlowController from "./portfolio_cash_flow_controller"
application.register("portfolio-cash-flow", PortfolioCashFlowController)

import PurchaseOrderController from "./purchase_order_controller"
application.register("purchase-order", PurchaseOrderController)

import PoModificationsController from "./po_modifications_controller"
application.register("po-modifications", PoModificationsController)

import PoReceiptsController from "./po_receipts_controller"
application.register("po-receipts", PoReceiptsController)

import PoInvoicesController from "./po_invoices_controller"
application.register("po-invoices", PoInvoicesController)

import FundSourceController from "./fund_source_controller"
application.register("fund-source", FundSourceController)

import ProjectFundingController from "./project_funding_controller"
application.register("project-funding", ProjectFundingController)

import CapitalRequestFormController from "./capital_request_form_controller"
application.register("capital-request-form", CapitalRequestFormController)

import CapitalRequestAdminController from "./capital_request_admin_controller"
application.register("capital-request-admin", CapitalRequestAdminController)

import CapitalRequestDetailController from "./capital_request_detail_controller"
application.register("capital-request-detail", CapitalRequestDetailController)

import CapitalRequestScoringController from "./capital_request_scoring_controller"
application.register("capital-request-scoring", CapitalRequestScoringController)

import ScoringRubricFormController from "./scoring_rubric_form_controller"
application.register("scoring-rubric-form", ScoringRubricFormController)

import CipForecastChartController from "./cip_forecast_chart_controller"
application.register("cip-forecast-chart", CipForecastChartController)

import CipForecastFormController from "./cip_forecast_form_controller"
application.register("cip-forecast-form", CipForecastFormController)

import CipScenarioFormController from "./cip_scenario_form_controller"
application.register("cip-scenario-form", CipScenarioFormController)

import CipTimelineController from "./cip_timeline_controller"
application.register("cip-timeline", CipTimelineController)

import CipModalController from "./cip_modal_controller"
application.register("cip-modal", CipModalController)

import MultiCheckboxPickerController from "./multi_checkbox_picker_controller"
application.register("multi-checkbox-picker", MultiCheckboxPickerController)

import ConfirmDeleteController from "./confirm_delete_controller"
application.register("confirm-delete", ConfirmDeleteController)

import FolderFormModalController from "./folder_form_modal_controller"
application.register("folder-form-modal", FolderFormModalController)

import BiddingProjectsController from "./bidding_projects_controller"
application.register("bidding-projects", BiddingProjectsController)

import CollaboratorCardController from "./collaborator_card_controller"
application.register("collaborator-card", CollaboratorCardController)

import CompanyFormController from "./company_form_controller"
application.register("company-form", CompanyFormController)

import CompanySwitcherController from "./company_switcher_controller"
application.register("company-switcher", CompanySwitcherController)

import ConstructionProjectsController from "./construction_projects_controller"
application.register("construction-projects", ConstructionProjectsController)

import CustomerReportController from "./customer_report_controller"
application.register("customer-report", CustomerReportController)

import KpiReportController from "./kpi_report_controller"
application.register("kpi-report", KpiReportController)

import HeadcountReportController from "./headcount_report_controller"
application.register("headcount-report", HeadcountReportController)

import ProgressReportController from "./progress_report_controller"
application.register("progress-report", ProgressReportController)

import ControlPanelController from "./control_panel_controller"
application.register("control-panel", ControlPanelController)

import CpanelBiddingController from "./cpanel_bidding_controller"
application.register("cpanel-bidding", CpanelBiddingController)

import CpanelConstructionController from "./cpanel_construction_controller"
application.register("cpanel-construction", CpanelConstructionController)
// Company Settings → Finances → Cost codes (builder companies, Phelipe 2026-10-23)
import CpanelCostCodesController from "./cpanel_cost_codes_controller"
application.register("cpanel-cost-codes", CpanelCostCodesController)

import CpanelDevPunchlistKindsController from "./cpanel_dev_punchlist_kinds_controller"
application.register("cpanel-dev-punchlist-kinds", CpanelDevPunchlistKindsController)

import CpanelCurrenciesController from "./cpanel_currencies_controller"
application.register("cpanel-currencies", CpanelCurrenciesController)

import CpanelDevelopmentController from "./cpanel_development_controller"
application.register("cpanel-development", CpanelDevelopmentController)

import CpanelDocumentsController from "./cpanel_documents_controller"
application.register("cpanel-documents", CpanelDocumentsController)

import CpanelFinancesController from "./cpanel_finances_controller"
application.register("cpanel-finances", CpanelFinancesController)

import CpanelGroupsController from "./cpanel_groups_controller"
application.register("cpanel-groups", CpanelGroupsController)

import CpanelLocationsController from "./cpanel_locations_controller"
application.register("cpanel-locations", CpanelLocationsController)

import CpanelPermissionsController from "./cpanel_permissions_controller"
application.register("cpanel-permissions", CpanelPermissionsController)

import CpanelPunchlistKindsController from "./cpanel_punchlist_kinds_controller"
application.register("cpanel-punchlist-kinds", CpanelPunchlistKindsController)
import ActionItemDefaultsUndoController from "./action_item_defaults_undo_controller"
application.register("action-item-defaults-undo", ActionItemDefaultsUndoController)

import CpanelRealEstateController from "./cpanel_real_estate_controller"
application.register("cpanel-real-estate", CpanelRealEstateController)

import CdvFormController from "./cdv_form_controller"
application.register("cdv-form", CdvFormController)

import DdsFormController from "./dds_form_controller"
application.register("dds-form", DdsFormController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DesignProjectsController from "./design_projects_controller"
application.register("design-projects", DesignProjectsController)

import DesignKeyDatesController from "./design_key_dates_controller"
application.register("design-key-dates", DesignKeyDatesController)

import DesignStepController from "./design_step_controller"
application.register("design-step", DesignStepController)

import DocumentsController from "./documents_controller"
application.register("documents", DocumentsController)

import DocumentAuditDrawerController from "./document_audit_drawer_controller"
application.register("document-audit-drawer", DocumentAuditDrawerController)

import FinalizeControlsController from "./finalize_controls_controller"
application.register("finalize-controls", FinalizeControlsController)

import FolderWatchButtonController from "./folder_watch_button_controller"
application.register("folder-watch-button", FolderWatchButtonController)

import FolderActivityDrawerController from "./folder_activity_drawer_controller"
application.register("folder-activity-drawer", FolderActivityDrawerController)

import DocumentAuditSettingsController from "./document_audit_settings_controller"
application.register("document-audit-settings", DocumentAuditSettingsController)

import LegacyFinalMapController from "./legacy_final_map_controller"
application.register("legacy-final-map", LegacyFinalMapController)

import DrawingsSpecsController from "./drawings_specs_controller"
application.register("drawings-specs", DrawingsSpecsController)

import SpecificationsController from "./specifications_controller"
application.register("specifications", SpecificationsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DragScrollController from "./drag_scroll_controller"
application.register("drag-scroll", DragScrollController)

import DynamicListController from "./dynamic_list_controller"
application.register("dynamic-list", DynamicListController)

import EditBidDetailsController from "./edit_bid_details_controller"
application.register("edit-bid-details", EditBidDetailsController)

import EditBidSettingsController from "./edit_bid_settings_controller"
application.register("edit-bid-settings", EditBidSettingsController)

import EditMeetingsController from "./edit_meetings_controller"
application.register("edit-meetings", EditMeetingsController)

import EditBiddingContractorsController from "./edit_bidding_contractors_controller"
application.register("edit-bidding-contractors", EditBiddingContractorsController)

import EditDevTeamController from "./edit_dev_team_controller"
application.register("edit-dev-team", EditDevTeamController)

// Owner's Reps (James / Phelipe 2026-10-20): Settings tab + Team page tab.
import OwnerRepSettingsController from "./owner_rep_settings_controller"
application.register("owner-rep-settings", OwnerRepSettingsController)
import OwnerRepsTabController from "./owner_reps_tab_controller"
application.register("owner-reps-tab", OwnerRepsTabController)
import OwnerRepsPanelController from "./owner_reps_panel_controller"
application.register("owner-reps-panel", OwnerRepsPanelController)

import EditLiquidatedDamagesController from "./edit_liquidated_damages_controller"
application.register("edit-liquidated-damages", EditLiquidatedDamagesController)

import EditLocationController from "./edit_location_controller"
application.register("edit-location", EditLocationController)

import EditProjectInfoController from "./edit_project_info_controller"
application.register("edit-project-info", EditProjectInfoController)

import EditReDetailsController from "./edit_re_details_controller"
application.register("edit-re-details", EditReDetailsController)

import EditReLocationController from "./edit_re_location_controller"
application.register("edit-re-location", EditReLocationController)

import EditReResponsibilitiesController from "./edit_re_responsibilities_controller"
application.register("edit-re-responsibilities", EditReResponsibilitiesController)

import EditReTeamController from "./edit_re_team_controller"
application.register("edit-re-team", EditReTeamController)

import ExternalUsersSelectController from "./external_users_select_controller"
application.register("external-users-select", ExternalUsersSelectController)

import EvaluationsController from "./evaluations_controller"
application.register("evaluations", EvaluationsController)

import FavoriteController from "./favorite_controller"
application.register("favorite", FavoriteController)
import HideProjectController from "./hide_project_controller"
application.register("hide-project", HideProjectController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import TemplateEditorController from "./template_editor_controller"
application.register("template-editor", TemplateEditorController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import IntercomController from "./intercom_controller"
application.register("intercom", IntercomController)

import KanbanDragController from "./kanban_drag_controller"
application.register("kanban-drag", KanbanDragController)

import KanbanScrollSyncController from "./kanban_scroll_sync_controller"
application.register("kanban-scroll-sync", KanbanScrollSyncController)

import ManageCollaboratorsController from "./manage_collaborators_controller"
application.register("manage-collaborators", ManageCollaboratorsController)

import ManageTeamController from "./manage_team_controller"
application.register("manage-team", ManageTeamController)

import MemberMultiSelectController from "./member_multi_select_controller"
application.register("member-multi-select", MemberMultiSelectController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import LazyContentController from "./lazy_content_controller"
application.register("lazy-content", LazyContentController)

import NewCompanyController from "./new_company_controller"
application.register("new-company", NewCompanyController)

import NotificationTogglesController from "./notification_toggles_controller"
application.register("notification-toggles", NotificationTogglesController)

import OwnerMembersController from "./owner_members_controller"
application.register("owner-members", OwnerMembersController)

import PasswordRulesController from "./password_rules_controller"
application.register("password-rules", PasswordRulesController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import PdfCompareController from "./pdf_compare_controller"
application.register("pdf-compare", PdfCompareController)

import PendingItemsController from "./pending_items_controller"
application.register("pending-items", PendingItemsController)

import PhotoLightboxController from "./photo_lightbox_controller"
import SiteCapturesController from "./site_captures_controller"
application.register("photo-lightbox", PhotoLightboxController)
application.register("site-captures", SiteCapturesController)

import PhotoMarkupController from "./photo_markup_controller"
application.register("photo-markup", PhotoMarkupController)

import PhotosController from "./photos_controller"
application.register("photos", PhotosController)

import PhotoPickerController from "./photo_picker_controller"
application.register("photo-picker", PhotoPickerController)

import PortfolioExpandController from "./portfolio_expand_controller"
application.register("portfolio-expand", PortfolioExpandController)

import PortfolioMapController from "./portfolio_map_controller"
application.register("portfolio-map", PortfolioMapController)

import PortfolioDashboardController from "./portfolio_dashboard_controller"
application.register("portfolio-dashboard", PortfolioDashboardController)

import PortfolioInsightsController from "./portfolio_insights_controller"
application.register("portfolio-insights", PortfolioInsightsController)

import PortfolioAiSummaryController from "./portfolio_ai_summary_controller"
application.register("portfolio-ai-summary", PortfolioAiSummaryController)

import PortfolioSettingsController from "./portfolio_settings_controller"
application.register("portfolio-settings", PortfolioSettingsController)

import PortfolioThemeController from "./portfolio_theme_controller"
application.register("portfolio-theme", PortfolioThemeController)

import PortfolioPresetController from "./portfolio_preset_controller"
application.register("portfolio-preset", PortfolioPresetController)

import PortfolioPresetFormController from "./portfolio_preset_form_controller"
application.register("portfolio-preset-form", PortfolioPresetFormController)

import PortfolioColumnsController from "./portfolio_columns_controller"
application.register("portfolio-columns", PortfolioColumnsController)

import PortfolioPresetManageController from "./portfolio_preset_manage_controller"
application.register("portfolio-preset-manage", PortfolioPresetManageController)

import PortfolioAlertManageController from "./portfolio_alert_manage_controller"
application.register("portfolio-alert-manage", PortfolioAlertManageController)

import PortfolioAlertFormController from "./portfolio_alert_form_controller"
application.register("portfolio-alert-form", PortfolioAlertFormController)

import PortfolioAlertLauncherController from "./portfolio_alert_launcher_controller"
application.register("portfolio-alert-launcher", PortfolioAlertLauncherController)

import PortfolioSnapshotTriggerController from "./portfolio_snapshot_trigger_controller"
application.register("portfolio-snapshot-trigger", PortfolioSnapshotTriggerController)

import PortfolioTrendChartsController from "./portfolio_trend_charts_controller"
application.register("portfolio-trend-charts", PortfolioTrendChartsController)

import PortfolioShareController from "./portfolio_share_controller"
application.register("portfolio-share", PortfolioShareController)

import PortfolioExportController from "./portfolio_export_controller"
application.register("portfolio-export", PortfolioExportController)

import PortfolioScheduleReportController from "./portfolio_schedule_report_controller"
application.register("portfolio-schedule-report", PortfolioScheduleReportController)

import PortfolioScheduledReportsManageController from "./portfolio_scheduled_reports_manage_controller"
application.register("portfolio-scheduled-reports-manage", PortfolioScheduledReportsManageController)

import PortfolioScheduledReportsLauncherController from "./portfolio_scheduled_reports_launcher_controller"
application.register("portfolio-scheduled-reports-launcher", PortfolioScheduledReportsLauncherController)

import PortfolioConfigExportController from "./portfolio_config_export_controller"
application.register("portfolio-config-export", PortfolioConfigExportController)

import PortfolioConfigImportController from "./portfolio_config_import_controller"
application.register("portfolio-config-import", PortfolioConfigImportController)

import PortfolioPackagesController from "./portfolio_packages_controller"
application.register("portfolio-packages", PortfolioPackagesController)

import KeyContactsController from "./key_contacts_controller"
application.register("key-contacts", KeyContactsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ProjectDashboardController from "./project_dashboard_controller"
application.register("project-dashboard", ProjectDashboardController)

import BoardCardController from "./board_card_controller"
import BoardPhaseMoveController from "./board_phase_move_controller"
application.register("board-card", BoardCardController)
application.register("board-phase-move", BoardPhaseMoveController)

import FeedbackListController from "./feedback_list_controller"
import InstantFeedbackController from "./instant_feedback_controller"
import FeedbackDetailController from "./feedback_detail_controller"
application.register("feedback-list", FeedbackListController)
application.register("instant-feedback", InstantFeedbackController)
application.register("feedback-detail", FeedbackDetailController)
import VideoSpeedController from "./video_speed_controller"
application.register("video-speed", VideoSpeedController)

import ChecklistTemplateController from "./checklist_template_controller"
application.register("checklist-template", ChecklistTemplateController)

import BoardLabelsController from "./board_labels_controller"
application.register("board-labels", BoardLabelsController)

import InternalScheduleController from "./internal_schedule_controller"
application.register("internal-schedule", InternalScheduleController)

import DashboardAiChatController from "./dashboard_ai_chat_controller"
application.register("dashboard-ai-chat", DashboardAiChatController)

import TrendChartCardController from "./trend_chart_card_controller"
application.register("trend-chart-card", TrendChartCardController)

import DashboardGridController from "./dashboard_grid_controller"
application.register("dashboard-grid", DashboardGridController)

import ProfileFormController from "./profile_form_controller"
application.register("profile-form", ProfileFormController)

import ProjectAdminController from "./project_admin_controller"
application.register("project-admin", ProjectAdminController)

import ProjectDesignStepsController from "./project_design_steps_controller"
application.register("project-design-steps", ProjectDesignStepsController)

import ProjectBidsController from "./project_bids_controller"
application.register("project-bids", ProjectBidsController)

import ProjectListScrollController from "./project_list_scroll_controller"
application.register("project-list-scroll", ProjectListScrollController)

import ProjectMergeController from "./project_merge_controller"
application.register("project-merge", ProjectMergeController)

import ProcoreController from "./procore_controller"
application.register("procore", ProcoreController)

import ProcoreItemsController from "./procore_items_controller"
application.register("procore-items", ProcoreItemsController)
import ProcoreDetailsController from "./procore_details_controller"
application.register("procore-details", ProcoreDetailsController)

import ProjectCoverController from "./project_cover_controller"
application.register("project-cover", ProjectCoverController)

import ProjectShowController from "./project_show_controller"
application.register("project-show", ProjectShowController)

import ProjectSidebarController from "./project_sidebar_controller"
application.register("project-sidebar", ProjectSidebarController)

import ProjectSwitcherController from "./project_switcher_controller"
application.register("project-switcher", ProjectSwitcherController)

import ProjectWizardController from "./project_wizard_controller"
application.register("project-wizard", ProjectWizardController)

import ReRoleFieldController from "./re_role_field_controller"
application.register("re-role-field", ReRoleFieldController)

import RealEstateProjectsController from "./real_estate_projects_controller"
application.register("real-estate-projects", RealEstateProjectsController)

import ReportFormController from "./report_form_controller"
application.register("report-form", ReportFormController)

import ResendCalendarInviteController from "./resend_calendar_invite_controller"
application.register("resend-calendar-invite", ResendCalendarInviteController)

import RoleMaskGuardController from "./role_mask_guard_controller"
application.register("role-mask-guard", RoleMaskGuardController)
// "Mask project as a user" pop-up search (2026-10-10).
import RoleMaskPickerController from "./role_mask_picker_controller"
application.register("role-mask-picker", RoleMaskPickerController)

// Roles and permissions (pmfit K6-7): Team page pop-ups + the toast for
// requests a tool permission refused.
import AccessEditorController from "./access_editor_controller"
application.register("access-editor", AccessEditorController)
import AccessGuardController from "./access_guard_controller"
application.register("access-guard", AccessGuardController)
import AccessOverviewController from "./access_overview_controller"
application.register("access-overview", AccessOverviewController)
import AccessSsoController from "./access_sso_controller"
application.register("access-sso", AccessSsoController)

import ReportPhotoLightboxController from "./report_photo_lightbox_controller"
application.register("report-photo-lightbox", ReportPhotoLightboxController)

import ReportsController from "./reports_controller"
application.register("reports", ReportsController)

import ReportBuilderController from "./report_builder_controller"
application.register("report-builder", ReportBuilderController)

import ReportFilterLogicController from "./report_filter_logic_controller"
application.register("report-filter-logic", ReportFilterLogicController)

import ReportFormulaColumnController from "./report_formula_column_controller"
application.register("report-formula-column", ReportFormulaColumnController)

import ReportChartBlockController from "./report_chart_block_controller"
application.register("report-chart-block", ReportChartBlockController)

// Phase 2.8 Tier 3 — schedule + snapshot history + diff
import ReportScheduleController from "./report_schedule_controller"
application.register("report-schedule", ReportScheduleController)

import ReportSnapshotHistoryController from "./report_snapshot_history_controller"
application.register("report-snapshot-history", ReportSnapshotHistoryController)

import ReportDiffController from "./report_diff_controller"
application.register("report-diff", ReportDiffController)

// Phase 2.8 Tier 4 — Conversational Builder modal
import ReportAiDraftController from "./report_ai_draft_controller"
application.register("report-ai-draft", ReportAiDraftController)

import RealEstateStepsController from "./real_estate_steps_controller"
application.register("real-estate-steps", RealEstateStepsController)

// § 3.5 Tier 6 — RFI detail interactions (response form, ACC sync,
// conflict resolution).
import RfiDetailController from "./rfi_detail_controller"
application.register("rfi-detail", RfiDetailController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SpecDrawingsSelectController from "./spec_drawings_select_controller"
application.register("spec-drawings-select", SpecDrawingsSelectController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SovController from "./sov_controller"
application.register("sov", SovController)

import SovEditorController from "./sov_editor_controller"
application.register("sov-editor", SovEditorController)

import SsoController from "./sso_controller"
application.register("sso", SsoController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import SupportModalController from "./support_modal_controller"
application.register("support-modal", SupportModalController)

import TagExpandController from "./tag_expand_controller"
application.register("tag-expand", TagExpandController)

import TeamCardController from "./team_card_controller"
application.register("team-card", TeamCardController)

import TeamController from "./team_controller"
application.register("team", TeamController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TruncateTooltipController from "./truncate_tooltip_controller"
application.register("truncate-tooltip", TruncateTooltipController)

import UniDashboardController from "./uni_dashboard_controller"
application.register("uni-dashboard", UniDashboardController)

import TeamMemberController from "./team_member_controller"
application.register("team-member", TeamMemberController)

import ResponsibilitiesAssignController from "./responsibilities_assign_controller"
application.register("responsibilities-assign", ResponsibilitiesAssignController)

import CloseoutController from "./closeout_controller"
application.register("closeout", CloseoutController)

import LiveSubmitController from "./live_submit_controller"
application.register("live-submit", LiveSubmitController)

import FrameSearchController from "./frame_search_controller"
application.register("frame-search", FrameSearchController)

import FeeScheduleController from "./fee_schedule_controller"
application.register("fee-schedule", FeeScheduleController)

import FinanceDashboardController from "./finance_dashboard_controller"
application.register("finance-dashboard", FinanceDashboardController)
import FundManagementController from "./fund_management_controller"
application.register("fund-management", FundManagementController)
import FundNumbersController from "./fund_numbers_controller"
application.register("fund-numbers", FundNumbersController)

import OvFeeScheduleController from "./ov_fee_schedule_controller"
application.register("ov-fee-schedule", OvFeeScheduleController)

import FeeAdjustmentController from "./fee_adjustment_controller"
application.register("fee-adjustment", FeeAdjustmentController)

import ChangeOrderController from "./change_order_controller"
application.register("change-order", ChangeOrderController)

import LegacyChangeOrderController from "./legacy_change_order_controller"
application.register("legacy-change-order", LegacyChangeOrderController)

import ChangePropertyController from "./change_property_controller"
application.register("change-property", ChangePropertyController)

import ProposedChangeOrderController from "./proposed_change_order_controller"
application.register("proposed-change-order", ProposedChangeOrderController)

import OvFeeAdjustmentController from "./ov_fee_adjustment_controller"
application.register("ov-fee-adjustment", OvFeeAdjustmentController)

import ConsultantPayRequestController from "./consultant_pay_request_controller"
application.register("consultant-pay-request", ConsultantPayRequestController)

import ContractorPayRequestController from "./contractor_pay_request_controller"
application.register("contractor-pay-request", ContractorPayRequestController)

import ContractsController from "./contracts_controller"
application.register("contracts", ContractsController)

import ContractWorkspaceController from "./contract_workspace_controller"
application.register("contract-workspace", ContractWorkspaceController)

import ReceivedContractController from "./received_contract_controller"
application.register("received-contract", ReceivedContractController)

import ContractPdfSpotsController from "./contract_pdf_spots_controller"
application.register("contract-pdf-spots", ContractPdfSpotsController)

// #27: bid upload → AI fee schedule extraction → per-line approve/decline
// on the contract workspace (bridges into Sub Payments when fully signed).
import ContractFeeScheduleController from "./contract_fee_schedule_controller"
application.register("contract-fee-schedule", ContractFeeScheduleController)

import OwnerExpensesController from "./owner_expenses_controller"
application.register("owner-expenses", OwnerExpensesController)

import OvPayRequestController from "./ov_pay_request_controller"
application.register("ov-pay-request", OvPayRequestController)

import VendorManagementsController from "./vendor_managements_controller"
application.register("vendor-managements", VendorManagementsController)

import SubPayRequestController from "./sub_pay_request_controller"
application.register("sub-pay-request", SubPayRequestController)

import SubChangePageController from "./sub_change_page_controller"
application.register("sub-change-page", SubChangePageController)

import GooglePlacesController from "./google_places_controller"
application.register("google-places", GooglePlacesController)

import GcProjectFormController from "./gc_project_form_controller"
application.register("gc-project-form", GcProjectFormController)

import CategoryManagerController from "./category_manager_controller"
application.register("category-manager", CategoryManagerController)

import TzDefaultController from "./tz_default_controller"
application.register("tz-default", TzDefaultController)

import GanttController from "./gantt_controller"
application.register("gantt", GanttController)

import ScheduleHealthController from "./schedule_health_controller"
application.register("schedule-health", ScheduleHealthController)

import UvuFormController from "./uvu_form_controller"
application.register("uvu-form", UvuFormController)

import ImgHandlerController from "./img_handler_controller"
application.register("img-handler", ImgHandlerController)

import ModalToggleController from "./modal_toggle_controller"
application.register("modal-toggle", ModalToggleController)
// Phase 2.6 Tier 1 — Risk Management
import RiskFormController from "./risk_form_controller"
application.register("risk-form", RiskFormController)

import RiskFilterController from "./risk_filter_controller"
application.register("risk-filter", RiskFilterController)

import RiskDetailTabsController from "./risk_detail_tabs_controller"
application.register("risk-detail-tabs", RiskDetailTabsController)

import RiskCategoriesController from "./risk_categories_controller"
application.register("risk-categories", RiskCategoriesController)

// Phase 2.6 Tier 2 — Mitigations + Links panels
import RiskMitigationController from "./risk_mitigation_controller"
application.register("risk-mitigation", RiskMitigationController)

import RiskLinkController from "./risk_link_controller"
application.register("risk-link", RiskLinkController)

// Phase 2.6 Tier 3 — Risk rule admin form (live preview)
import RiskRuleFormController from "./risk_rule_form_controller"
application.register("risk-rule-form", RiskRuleFormController)

// Phase 2.7 Tier 1 — Meeting Minutes
import MeetingFormController from "./meeting_form_controller"
application.register("meeting-form", MeetingFormController)

import MeetingRecurrenceController from "./meeting_recurrence_controller"
application.register("meeting-recurrence", MeetingRecurrenceController)

import MeetingGuestsController from "./meeting_guests_controller"
application.register("meeting-guests", MeetingGuestsController)

import MeetingReminderController from "./meeting_reminder_controller"
application.register("meeting-reminder", MeetingReminderController)

import MinutesNotifyController from "./minutes_notify_controller"
application.register("minutes-notify", MinutesNotifyController)

import MeetingUiController from "./meeting_ui_controller"
application.register("meeting-ui", MeetingUiController)

import AttendeePickerController from "./attendee_picker_controller"
application.register("attendee-picker", AttendeePickerController)

import MeetingPageAgendaController from "./meeting_page_agenda_controller"
application.register("meeting-page-agenda", MeetingPageAgendaController)

import MeetingColumnsController from "./meeting_columns_controller"
import InternalExpenseController from "./internal_expense_controller"
application.register("meeting-columns", MeetingColumnsController)
application.register("internal-expense", InternalExpenseController)

import MeetingDurationController from "./meeting_duration_controller"
application.register("meeting-duration", MeetingDurationController)

import MeetingStartTzController from "./meeting_start_tz_controller"
application.register("meeting-start-tz", MeetingStartTzController)

import TimeSelectController from "./time_select_controller"
application.register("time-select", TimeSelectController)

import EmailChipsController from "./email_chips_controller"
application.register("email-chips", EmailChipsController)

import MeetingLocationController from "./meeting_location_controller"
application.register("meeting-location", MeetingLocationController)

import MeetingAgendaController from "./meeting_agenda_controller"
application.register("meeting-agenda", MeetingAgendaController)

import ProjectSettingsHistoryController from "./project_settings_history_controller"
application.register("project-settings-history", ProjectSettingsHistoryController)

import MeetingTemplateAdminController from "./meeting_template_admin_controller"
application.register("meeting-template-admin", MeetingTemplateAdminController)

import TemplateTopicsController from "./template_topics_controller"
application.register("template-topics", TemplateTopicsController)

import MeetingItemController from "./meeting_item_controller"
application.register("meeting-item", MeetingItemController)

import MeetingItemLinkDraftController from "./meeting_item_link_draft_controller"
application.register("meeting-item-link-draft", MeetingItemLinkDraftController)

import MeetingSyncController from "./meeting_sync_controller"
application.register("meeting-sync", MeetingSyncController)

// Phase 2.7 Tier 2 — recurring series, action-create, polymorphic links
import MeetingSeriesController from "./meeting_series_controller"
application.register("meeting-series", MeetingSeriesController)

import MeetingActionController from "./meeting_action_controller"
application.register("meeting-action", MeetingActionController)

import MeetingLinkController from "./meeting_link_controller"
application.register("meeting-link", MeetingLinkController)

import MinutesFilterController from "./minutes_filter_controller"
application.register("minutes-filter", MinutesFilterController)
import MinutesAssignController from "./minutes_assign_controller"
application.register("minutes-assign", MinutesAssignController)

// Phase 2.7 Tier 3 — calendar copy + topic admin drag-to-reorder
import MeetingCalendarController from "./meeting_calendar_controller"
application.register("meeting-calendar", MeetingCalendarController)

import MeetingTopicAdminController from "./meeting_topic_admin_controller"
application.register("meeting-topic-admin", MeetingTopicAdminController)

import MeetingAiDraftController from "./meeting_ai_draft_controller"
application.register("meeting-ai-draft", MeetingAiDraftController)
import PastMeetingTranscriptController from "./past_meeting_transcript_controller"
application.register("past-meeting-transcript", PastMeetingTranscriptController)

// Phase 2.9 Tier 2 — Approval Workflow visual builder + pool picker
import WorkflowBuilderController from "./workflow_builder_controller"
application.register("workflow-builder", WorkflowBuilderController)

import ApproverPoolPickerController from "./approver_pool_picker_controller"
application.register("approver-pool-picker", ApproverPoolPickerController)

import PoolFormController from "./pool_form_controller"
application.register("pool-form", PoolFormController)

// § 3.2 Tier 3/4 — manual "Send to ERP" trigger from a project's PR or CO page.
import ErpSyncController from "./erp_sync_controller"
application.register("erp-sync", ErpSyncController)

// Phase 2.11 Tier 1 — Asset Planning & FM Handoff
import AssetFilterController from "./asset_filter_controller"
application.register("asset-filter", AssetFilterController)

import AssetDetailModalController from "./asset_detail_modal_controller"
application.register("asset-detail-modal", AssetDetailModalController)

import AssetFormController from "./asset_form_controller"
application.register("asset-form", AssetFormController)

import AssetDetailTabsController from "./asset_detail_tabs_controller"
application.register("asset-detail-tabs", AssetDetailTabsController)

import AssetConfirmController from "./asset_confirm_controller"
application.register("asset-confirm", AssetConfirmController)

import AssetWarrantyController from "./asset_warranty_controller"
application.register("asset-warranty", AssetWarrantyController)

import AssetHandoffGuardController from "./asset_handoff_guard_controller"
application.register("asset-handoff-guard", AssetHandoffGuardController)

import PublicWarrantyClaimController from "./public_warranty_claim_controller"
application.register("public-warranty-claim", PublicWarrantyClaimController)

// Phase 2.11 Tier 3 — mobile-friendly asset photo capture + bulk update
import AssetPhotosController from "./asset_photos_controller"
application.register("asset-photos", AssetPhotosController)

import AssetBulkUpdateController from "./asset_bulk_update_controller"
application.register("asset-bulk-update", AssetBulkUpdateController)

// Phase 2.11 Tier 4 — closeout deliverables (per-type accordion + chip uploads)
import AssetDeliverablesController from "./asset_deliverables_controller"
application.register("asset-deliverables", AssetDeliverablesController)

// Phase 2.12 Tier 3 — dashboard layout templates + tabs + Ask in English.
import DashboardLayoutTemplatesController from "./dashboard_layout_templates_controller"
application.register("dashboard-layout-templates", DashboardLayoutTemplatesController)

// Phase 2.12 (Edit Mode B) — on-page widget editing for the portfolio dashboard.
import PortfolioEditModeController from "./portfolio_edit_mode_controller"
application.register("portfolio-edit-mode", PortfolioEditModeController)

import DashboardTabsController from "./dashboard_tabs_controller"
application.register("dashboard-tabs", DashboardTabsController)

import AskInEnglishController from "./ask_in_english_controller"
application.register("ask-in-english", AskInEnglishController)

import DashboardNoteController from "./dashboard_note_controller"
application.register("dashboard-note", DashboardNoteController)

import InflationToggleController from "./inflation_toggle_controller"
application.register("inflation-toggle", InflationToggleController)

import AiNarrativeToggleController from "./ai_narrative_toggle_controller"
application.register("ai-narrative-toggle", AiNarrativeToggleController)

import VendorWeightsController from "./vendor_weights_controller"
application.register("vendor-weights", VendorWeightsController)

// Phase 3.1 Tier 2 — Integrations marketplace.
import MarketplaceGridController from "./marketplace_grid_controller"
application.register("marketplace-grid", MarketplaceGridController)

import IntegrationListingController from "./integration_listing_controller"
application.register("integration-listing", IntegrationListingController)

import IntegrationRequestController from "./integration_request_controller"
application.register("integration-request", IntegrationRequestController)

// External-integration showcase dashboards (CBRE pilot).
import IntegrationDashboardController from "./integration_dashboard_controller"
application.register("integration-dashboard", IntegrationDashboardController)

// "Update" column hover cards (portfolio + integration project tables).
import InfoTipController from "./info_tip_controller"
application.register("info-tip", InfoTipController)

// Phase 3.1 Tier 3 — admin / connection-detail surfaces.
import ConnectionDetailController from "./connection_detail_controller"
application.register("connection-detail", ConnectionDetailController)

import IntegrationAdminCategoriesController from "./integration_admin_categories_controller"
application.register("integration-admin-categories", IntegrationAdminCategoriesController)

import IntegrationAdminByCategoryController from "./integration_admin_by_category_controller"
application.register("integration-admin-by-category", IntegrationAdminByCategoryController)

import IntegrationAdminProvidersController from "./integration_admin_providers_controller"
application.register("integration-admin-providers", IntegrationAdminProvidersController)

import IntegrationAdminProviderFormController from "./integration_admin_provider_form_controller"
application.register("integration-admin-provider-form", IntegrationAdminProviderFormController)

import IntegrationAdminRequestsController from "./integration_admin_requests_controller"
application.register("integration-admin-requests", IntegrationAdminRequestsController)

// Phase 3.1 Tier 4 — Connect-button on a marketplace listing detail.
import ConnectButtonController from "./connect_button_controller"
application.register("connect-button", ConnectButtonController)

// § 3.14 Tier 2 — DocuSign "Send for Signature" trigger + page-level modal.
import DocusignSendModalTriggerController from "./docusign_send_modal_trigger_controller"
application.register("docusign-send-modal-trigger", DocusignSendModalTriggerController)
import DocusignSendModalController from "./docusign_send_modal_controller"
application.register("docusign-send-modal", DocusignSendModalController)

// Phase 3.1 Tier 5 — Project Settings → Integrations sub-tab + Admin Overview.
import ProjectIntegrationLinksController from "./project_integration_links_controller"
application.register("project-integration-links", ProjectIntegrationLinksController)

import ProjectCamerasController from "./project_cameras_controller"
application.register("project-cameras", ProjectCamerasController)

import ProjectIntegrationLinkFormController from "./project_integration_link_form_controller"
application.register("project-integration-link-form", ProjectIntegrationLinkFormController)

import ModalDismissController from "./modal_dismiss_controller"
application.register("modal-dismiss", ModalDismissController)

import IntegrationOverviewController from "./integration_overview_controller"
application.register("integration-overview", IntegrationOverviewController)

// Phase 3.3 Tier 2 — flat-file template no-code mapping picker.
import FlatFileTemplateFormController from "./flat_file_template_form_controller"
application.register("flat-file-template-form", FlatFileTemplateFormController)

// Phase 3.3 Tier 3 — Generic SFTP "Test connection" button on the
// connection-detail Defaults panel.
import SftpDefaultsController from "./sftp_defaults_controller"
application.register("sftp-defaults", SftpDefaultsController)

// Phase 3.3 Tier 3 — flat-file schedule form panel (cadence + delivery
// destination swap-on-change).
import FlatFileScheduleFormController from "./flat_file_schedule_form_controller"
application.register("flat-file-schedule-form", FlatFileScheduleFormController)

// Phase 3.5 Tier 1 — generic copy-to-clipboard button used by the ACC
// Custom-Integration banner (and any future "copy this token" surface).
import CopyButtonController from "./copy_button_controller"
application.register("copy-button", CopyButtonController)

// Phase 3.5 Tier 1 — ACC project picker on the per-project linker form.
// Lazy-loads /connections/:id/acc_projects.json into the dropdown when
// the user picks an Autodesk connection.
import AccLinkerController from "./acc_linker_controller"
application.register("acc-linker", AccLinkerController)

// § 3.8 Tier 2 — Google Drive folder picker. Loads apis.google.com,
// authorizes the picker view with the connection's OAuth token, lets
// the user pick a single folder, and writes the selection into the
// per-project linker form's hidden fields.
import DriveFolderPickerController from "./drive_folder_picker_controller"
application.register("drive-folder-picker", DriveFolderPickerController)

// § 3.8 Tier 3 Step 40 — OneDrive / SharePoint File Picker v8.
// Opens a popup against onedrive.live.com/picker (or the tenant
// SharePoint host once Tier 6 wires that), runs the postMessage
// `initialize` → `activate` → `command:authenticate` handshake with the
// connection's access token, and writes the picked folder's id + name
// + webUrl into the per-project linker form's hidden fields.
import OnedriveFolderPickerController from "./onedrive_folder_picker_controller"
application.register("onedrive-folder-picker", OnedriveFolderPickerController)

// § 3.8 Tier 4 Step 47 — Dropbox build-our-own folder browser.
// Dropbox doesn't ship a hosted folder picker for backend OAuth
// flows (the Chooser is client-side only), so we render a click-to-
// expand left-rail tree against the /integrations/dropbox/folders
// endpoint that proxies /2/files/list_folder.
import DropboxFolderPickerController from "./dropbox_folder_picker_controller"
application.register("dropbox-folder-picker", DropboxFolderPickerController)

// § 3.8 Tier 5 Step 70 — Box Content Picker UI Element folder picker.
// Lazy-loads box-ui-elements/picker.js + matching picker.css from the
// Box CDN, mounts a folder-only ContentPicker authorized with the
// connection's downscoped picker token (base_explorer scope only via
// Box's token-exchange grant — server-side mint in Box::Adapter#mint_picker_token).
import BoxFolderPickerController from "./box_folder_picker_controller"
application.register("box-folder-picker", BoxFolderPickerController)

// § 3.5 Tier 2 — BIM index live status refresh + ACC Docs file picker.
import BimModelsIndexController from "./bim_models_index_controller"
application.register("bim-models-index", BimModelsIndexController)

import AccFilePickerController from "./acc_file_picker_controller"
application.register("acc-file-picker", AccFilePickerController)

// § 3.5 Tier 3 — Forge Viewer (APS LMV) embed + saved viewpoints +
// element selection + viewer-token mint + streaming meter.
import ForgeViewerController from "./forge_viewer_controller"
application.register("forge-viewer", ForgeViewerController)

// § 3.5 Tier 4 — Action-Item pin overlay. Mounts on the same root as
// `forge-viewer`; renders THREE.Sprite pins anchored to action items
// pinned to the model. Click → opens slide-over + restores viewpoint.
import BimPinOverlayController from "./bim_pin_overlay_controller"
application.register("bim-pin-overlay", BimPinOverlayController)

// § 3.5 Tier 4 — Right-rail "Action Items on This Model" panel. Reads
// the same /pins.json the overlay does so the rail and the in-scene
// sprites stay in lockstep.
import BimPinsRailController from "./bim_pins_rail_controller"
application.register("bim-pins-rail", BimPinsRailController)

// § 3.8 Tier 6 — Doc-sync conflict-policy radio group; toggles the
// "ConsLog overwrites cloud" amber warning when local_wins is picked.
import ConflictPolicyPickerController from "./conflict_policy_picker_controller"
application.register("conflict-policy-picker", ConflictPolicyPickerController)

// § 3.15 Tier 1 — project Notifications card. Manages the
// "Add Notification Webhook" modal (Slack / Teams paste-URL flow),
// per-row kebab actions (Send test / Re-enable / Delete), and the
// preflight Test button that posts to /test_url with the in-progress
// URL+kind before the row is saved.
import IncomingChatWebhookController from "./incoming_chat_webhook_controller"
application.register("incoming-chat-webhook", IncomingChatWebhookController)

// § 3.17 Tier 1 — video-meeting platform picker placeholder. Mounts
// on the `<select>` for ConsLog Video / Zoom / Microsoft Teams on
// the Pre-Bid modal, Bid-Closing form, and generic Meeting form.
import MeetingPlatformPickerController from "./meeting_platform_picker_controller"
application.register("meeting-platform-picker", MeetingPlatformPickerController)

// "Chat with your plans / specs" — collapsible AI side panel on the
// Drawings and Specifications pages (shared/_docs_ai_chat partial).
import DocsChatController from "./docs_chat_controller"
application.register("docs-chat", DocsChatController)

// "Try the Builder module" promo — top banner for Owner-persona
// companies that mostly hold contractor roles, its explainer modal,
// and the post-switch trial bar (shared/_builder_promo_banner).
import BuilderPromoController from "./builder_promo_controller"
application.register("builder-promo", BuilderPromoController)

// Public contract-signing page (token link from the signature email):
// consent gating for the Sign button + decline toggle.
import ContractSignController from "./contract_sign_controller"
application.register("contract-sign", ContractSignController)

// Builder-module SOV builder — the "Build SOV" dropdown on the Schedule
// of Values page: AI extract-from-file (upload + poll), add manually, or
// pull the company default list, all feeding the sov-editor review grid.
import SovExtractController from "./sov_extract_controller"
application.register("sov-extract", SovExtractController)

// AI local-market cost benchmark on the GC SOV grid — "Benchmark costs"
// button, per-line verdict chips, summary strip (anonymized Gemini call).
import SovBenchmarkController from "./sov_benchmark_controller"
application.register("sov-benchmark", SovBenchmarkController)

// Type-to-search dropdown for SOV Unit fields (build grid + read table);
// delegated — one instance on the page wrapper serves all unit inputs.
import UnitSelectController from "./unit_select_controller"
application.register("unit-select", UnitSelectController)

// Bid Q&A (roadmap #56) — question list + filters, ask modal with chip
// uploads, slide-over with private clarify chat + official answer, team
// tools (settings/hide/duplicate/publish addendum).
import BidQaController from "./bid_qa_controller"
application.register("bid-qa", BidQaController)

// Builder-module pay applications: list page (new-app modal + navigation)
// and the G702/G703 detail grid (autosave billing inputs, %↔$ fill, stored
// materials, payments, attachment chips, AI draft, signature chain builder).
import PayAppsController from "./pay_apps_controller"
application.register("pay-apps", PayAppsController)
import PayAppDetailController from "./pay_app_detail_controller"
application.register("pay-app-detail", PayAppDetailController)

// Signature chain panel (pay apps / PCOs / COs) — resend current signer.
import SignatureChainController from "./signature_chain_controller"
application.register("signature-chain", SignatureChainController)

// Buyout (GC→sub bidding) — packages index: New/Edit package modal, styled
// delete confirm, row click-through. Builder-persona project tab.
import BuyoutController from "./buyout_controller"
application.register("buyout", BuyoutController)

// Buyout package show page — Documents/Invites/Q&A/Bids sub-tabs, chip
// uploads (presign→PUT→register), invite modal, open/close transitions,
// Q&A answer/publish + GC-authored Q&A broadcast.
import BuyoutPackageController from "./buyout_package_controller"
application.register("buyout-package", BuyoutPackageController)

// Public (no-login) sub bid page — bid form + chip attachments, revise
// toggle, decline modal + undo, ask-a-question. Token-guarded routes.
import PublicSubBidController from "./public_sub_bid_controller"
application.register("public-sub-bid", PublicSubBidController)

// Buyout Sub Directory — SubVendor CRUD modals, trades chip input,
// client-side search/trade filters, clickable coverage chips.
import SubVendorsController from "./sub_vendors_controller"
application.register("sub-vendors", SubVendorsController)

// Builder change chain: PCO list (AI quote/CO-catcher), PCO detail grid,
// Change Orders (bundle PCOs), shared send-for-signatures modal.
import GcPcoController from "./gc_pco_controller"
application.register("gc-pco", GcPcoController)
import GcPcoDetailController from "./gc_pco_detail_controller"
application.register("gc-pco-detail", GcPcoDetailController)
import GcCoController from "./gc_co_controller"
application.register("gc-co", GcCoController)
import ChainBuilderController from "./chain_builder_controller"
application.register("chain-builder", ChainBuilderController)

// Sub Payments tab: contracts list + buyout board, contract detail (invoices
// in / payments out / waivers / compliance / portal), and the public
// sub-portal + COI upload pages (presign into hidden form fields).
import SubPaymentsController from "./sub_payments_controller"
application.register("sub-payments", SubPaymentsController)
import SubContractController from "./sub_contract_controller"
application.register("sub-contract", SubContractController)
import SubPortalController from "./sub_portal_controller"
application.register("sub-portal", SubPortalController)

// Public subcontractor set-up page: the documents a sub must provide before
// the contract is released for signature (Larry 2026-08-06).
import VendorDocsController from "./vendor_docs_controller"
application.register("vendor-docs", VendorDocsController)
// The builder side of the same feature: the master document list editor and
// the exception review page.
import CompanyDocumentsController from "./company_documents_controller"
application.register("company-documents", CompanyDocumentsController)
import DocsReviewController from "./docs_review_controller"
application.register("docs-review", DocsReviewController)

// Builder finance settings (autosave + A1 contract reader) and direct costs.
import BuilderSettingsController from "./builder_settings_controller"
application.register("builder-settings", BuilderSettingsController)
import DirectCostsController from "./direct_costs_controller"
application.register("direct-costs", DirectCostsController)

// Builder money views: company-wide money screen (#36/$1k layer), the
// per-project money dashboard (#29), and the AI project setup wizard (#53).
import BuilderMoneyController from "./builder_money_controller"
application.register("builder-money", BuilderMoneyController)
import BuilderDashboardController from "./builder_dashboard_controller"
application.register("builder-dashboard", BuilderDashboardController)
import BuilderOnboardingController from "./builder_onboarding_controller"
application.register("builder-onboarding", BuilderOnboardingController)

// ConsLog Meetings branded join page (/meet/:token): embeds the Daily room
// with the project's brand color (owner blue / builder orange).
import MeetJoinController from "./meet_join_controller"
application.register("meet-join", MeetJoinController)

// PCO "Acknowledge & send" modal (builder module): GC acknowledges + optionally
// emails the owner/others a no-login link to acknowledge (non-binding).
import PcoAckController from "./pco_ack_controller"
application.register("pco-ack", PcoAckController)

// Toolbox Chat (builder) / Project Chat (owner) — construction-module team
// chat slide-over: text, files, photos, voice notes, @tags, unread badges.
import ToolboxChatController from "./toolbox_chat_controller"
application.register("toolbox-chat", ToolboxChatController)
import DomEventsController from "./dom_events_controller"
application.register("dom-events", DomEventsController)
import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)
import ImgFallbackController from "./img_fallback_controller"
application.register("img-fallback", ImgFallbackController)
import TableSortController from "./table_sort_controller"
import FinanceRetentionToggleController from "./finance_retention_toggle_controller"
application.register("table-sort", TableSortController)
application.register("finance-retention-toggle", FinanceRetentionToggleController)

import ProjectDirectoryController from "./project_directory_controller"
application.register("project-directory", ProjectDirectoryController)
// The builder's project setup guide (Kloepfer K8-9, 2026-10-08).
import SetupGuideController from "./setup_guide_controller"
application.register("setup-guide", SetupGuideController)
import SetupGuideSettingController from "./setup_guide_setting_controller"
application.register("setup-guide-setting", SetupGuideSettingController)
import TimeForemanController from "./time_foreman_controller"
application.register("time-foreman", TimeForemanController)
// US phone numbers format themselves as you type (Kloepfer K8-8, 2026-10-08).
import PhoneFormatController from "./phone_format_controller"
application.register("phone-format", PhoneFormatController)

import TeamTasksController from "./team_tasks_controller"
application.register("team-tasks", TeamTasksController)
import CrewScheduleController from "./crew_schedule_controller"
application.register("crew-schedule", CrewScheduleController)
import SmartImportController from "./smart_import_controller"
application.register("smart-import", SmartImportController)
import ReportHistoryController from "./report_history_controller"
application.register("report-history", ReportHistoryController)
import SiteWalksController from "./site_walks_controller"
application.register("site-walks", SiteWalksController)
// Drone flights on the site map (pmfit K8-35): the Drone maps panel under the Site Walks row.
import DroneFlightsController from "./drone_flights_controller"
application.register("drone-flights", DroneFlightsController)
import DroneTerrainController from "./drone_terrain_controller"
application.register("drone-terrain", DroneTerrainController)

import SiteWalkMapController from "./site_walk_map_controller"
application.register("site-walk-map", SiteWalkMapController)
import ScheduleResourcesController from "./schedule_resources_controller"
application.register("schedule-resources", ScheduleResourcesController)
import SiteWalkAiController from "./site_walk_ai_controller"
application.register("site-walk-ai", SiteWalkAiController)
import SiteWalkReminderController from "./site_walk_reminder_controller"
application.register("site-walk-reminder", SiteWalkReminderController)
// Site Walks plans (Site Walks list #9, #16, #18): the site plan lined up on the map, and indoor walks on a floor plan.
import SitePlanController from "./site_plan_controller"
application.register("site-plan", SitePlanController)
import SiteWalkPlanController from "./site_walk_plan_controller"
application.register("site-walk-plan", SiteWalkPlanController)
// Action item emails in the chat (Phelipe 2026-09-29): the grey line's hover card, and the
// "opened from the email's link" signal (public page) / address-bar cleanup.
import EmailCardController from "./email_card_controller"
application.register("email-card", EmailCardController)
import EmailViewBeaconController from "./email_view_beacon_controller"
application.register("email-view-beacon", EmailViewBeaconController)
// ConsLog Help Center (Phelipe 2026-10-07): full-size screenshots.
import HelpCenterController from "./help_center_controller"
application.register("help-center", HelpCenterController)
import HelpChoiceController from "./help_choice_controller"
application.register("help-choice", HelpChoiceController)
// Record an outside call (pmfit K7-36, Phelipe 2026-10-08).
import CallRecorderController from "./call_recorder_controller"
application.register("call-recorder", CallRecorderController)
// Edit a company you registered: the pencil on a team card (pmfit K8-4, Larry 2026-10-08).
import RegisteredCompanyController from "./registered_company_controller"
application.register("registered-company", RegisteredCompanyController)
// New-project wizard drafts (pmfit K8-5, Larry 2026-10-08): saved as you go, a Draft card on the Projects page.
import WizardDraftController from "./wizard_draft_controller"
application.register("wizard-draft", WizardDraftController)
import ProjectDraftCardController from "./project_draft_card_controller"
application.register("project-draft-card", ProjectDraftCardController)
// Review before ConsLog (pmfit K8-31, 2026-10-08): the Pending review box on the Feedback Loop page.
import FeedbackReviewController from "./feedback_review_controller"
application.register("feedback-review", FeedbackReviewController)

// Follow-up questions on the Feedback Loop (Phelipe 2026-10-09): Admin → Ask the sender, and the public link's answer box.
import AdminFeedbackAskController from "./admin_feedback_ask_controller"
application.register("admin-feedback-ask", AdminFeedbackAskController)
import PublicFeedbackReplyController from "./public_feedback_reply_controller"
application.register("public-feedback-reply", PublicFeedbackReplyController)
import ProjectSearchController from "./project_search_controller"
application.register("project-search", ProjectSearchController)

// Studio / the Ask AI bubble (Phelipe 2026-10-16)
import StudioChatController from "./studio_chat_controller"
application.register("studio-chat", StudioChatController)
import FeedbackTabsController from "./feedback_tabs_controller"
application.register("feedback-tabs", FeedbackTabsController)
import StudioChangesController from "./studio_changes_controller"
application.register("studio-changes", StudioChangesController)
import PageBlocksController from "./page_blocks_controller"
import CustomFieldsController from "./custom_fields_controller"
import TableOrderController from "./table_order_controller"
application.register("page-blocks", PageBlocksController)
application.register("custom-fields", CustomFieldsController)
application.register("table-order", TableOrderController)
import PreconController from "./precon_controller"
application.register("precon", PreconController)
import PreconPlansController from "./precon_plans_controller"
application.register("precon-plans", PreconPlansController)
import PreconS1Controller from "./precon_s1_controller"
application.register("precon-s1", PreconS1Controller)
import PreconPackagesController from "./precon_packages_controller"
application.register("precon-packages", PreconPackagesController)
import PreconSubsController from "./precon_subs_controller"
application.register("precon-subs", PreconSubsController)
import PreconCodesController from "./precon_codes_controller"
application.register("precon-codes", PreconCodesController)
import PreconBidController from "./precon_bid_controller"
application.register("precon-bid", PreconBidController)
import PreconInviteController from "./precon_invite_controller"
application.register("precon-invite", PreconInviteController)
import PreconPickController from "./precon_pick_controller"
application.register("precon-pick", PreconPickController)
import PreconSettingsController from "./precon_settings_controller"
application.register("precon-settings", PreconSettingsController)
import PreconS456Controller from "./precon_s456_controller"
application.register("precon-s456", PreconS456Controller)
import PricingController from "./pricing_controller"
application.register("pricing", PricingController)
import ReceiptCcController from "./receipt_cc_controller"
application.register("receipt-cc", ReceiptCcController)
import BuilderBillingController from "./builder_billing_controller"
application.register("builder-billing", BuilderBillingController)
